import React from 'react';
import {Text} from '@priority-software/priority-style-react';
import {BusinessRuleActionTemplate} from './BusinessRuleActionTemplate';
import {BusinessRuleAction, businessRulesActionMap} from '../../../../constants';
import {IAlert} from '../../../../actions/proto';
import {texts} from '../../../../texts';

type Props = {
    activeAction?: number;
    onRuleUpdate: (data: Partial<IAlert>) => void;
};

export const AutomationActionTemplate = (props: Props) => {
    const {activeAction, onRuleUpdate} = props;
    const supportedProps = businessRulesActionMap[activeAction]?.fieldsSupport;

    if (activeAction === BusinessRuleAction.UserVerification) {
        return (
            <Text tag="p" skin="paragraph-1">
                {texts.user_verification_content}
            </Text>
        );
    }

    if (!supportedProps) return null;

    return (
        <BusinessRuleActionTemplate
            {...supportedProps}
            onRuleUpdate={onRuleUpdate}
            activeAction={activeAction}
        />
    );
};
